<template>
    <div class="view map">
        <MapHome></MapHome>

        <v-btn fab dark large bottom right fixed color="green" :to="{name: 'SurveyAdd'}" v-if="isAuthenticated">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import MapHome from '../components/detail/map/MapHome';

    export default {
        name: 'Home',
        components: {
            MapHome
        },
        computed: {
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            }
        }
    };
</script>

<style lang="scss">
    /* empty */
</style>
